/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this.parent = this.closest('.product-recommendations--parent');
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}
                  
					if (typeof techTl !== 'undefined') {
						techTl.revert();
						techTl.clear();
						technologyScroll();
					}

					// 添加IntersectionObserver来监听商品推荐区域的可见性
					const observer = new IntersectionObserver((entries) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								// 获取已经通过Liquid预处理的商品数据
								const productsDataScript = this.querySelector('script');
								if (productsDataScript) {
									// 执行script中的代码
									eval(productsDataScript.textContent);
								}
								// 取消观察
								observer.disconnect();
							}
						});
					}, {
						threshold: 0.1
					});

					// 开始观察商品推荐区域
					observer.observe(this);
				}

				this.classList.add('product-recommendations--loaded');
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);
